import React from 'react';
import classNames from 'classnames';

import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { API, Auth } from 'aws-amplify';
import { FaInfoCircle, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import S3_CONFIG from '../../../config/s3.json'

import { LdsSpinner } from '../../Util/LoadingIcons'

let customPrefix = {
    public: 'public/',
    protected: 'protected/',
    private: 'jobs/*/'
}

class JobIds extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            requestIdsList: [],
        };
        this.handleInputChange = this.handleInputChange.bind(this);

        // Avoid setting the state after the component was unmounted
        // https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
        this._isMounted = false;
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    componentDidMount() {
        this._isMounted = true;
        this._isMounted && this.api_get();

        Auth.currentAuthenticatedUser().then(user => {
            this.setState({currentAuth: user.attributes});
            customPrefix.private = `${S3_CONFIG.PREFIX}/${user.attributes['custom:organization']}/`
        }).catch(err => console.log(err))
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate() {
    }

    api_get() {
        let options = {
            headers: {},
            response: true,
            queryStringParameters: {
                requestType: this.props.model,
                callType: this.props.name,
            }
        }

        API.get("AQcast", "/request/", options)
            .then(response => {
                    this._isMounted && this.setState({
                        requestIdsList: [{requestId: 'NONE', description: 'None'}].concat(response.data.requestIds)
                    });
            })
            .catch(error => console.log(error))
    }

    showJobInfo() {
        if ((this.state.requestIdsList === null) || (this.state.requestIdsList === undefined)){
            return (<LdsSpinner/>)
        } else {
            return (
                <div style={{padding:'10px'}}>
                    {this.props.title}
                    <TextField
                        className={classNames(this.props.classes.margin, this.props.classes.textField)}
                        select
                        style={{width: '194px'}}
                        name={this.props.name}
                        value={this.props.value}
                        onClick={() => this.api_get()}
                        onChange={this.props.handleInputChange}>

                        {this.state.requestIdsList.map(option => (
                            <MenuItem key={option.requestId} value={option.requestId}>
                                {option.description}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>
            )
        }
    }

    render() {
        return (
            <div >
                {this.showJobInfo()}
            </div>
        )
    }
}

export default JobIds;
